
const segmentos = [
  {
    'id': 125,
    'nome': 'Agronegócio'
  },
  {
    'id': 126,
    'nome': 'Alimentos, bebidas e Fumo'
  },
  {
    'id': 127,
    'nome': 'Automotivo e autopeças'
  },
  {
    'id': 128,
    'nome': 'Comércio Varejista'
  },
  {
    'id': 129,
    'nome': 'Eletroeletrônico'
  },
  {
    'id': 130,
    'nome': 'Farmacêutico'
  },
  {
    'id': 131,
    'nome': 'Máquina e Equipamento'
  },
  {
    'id': 132,
    'nome': 'Construção Civil'
  },
  {
    'id': 133,
    'nome': 'Químico e Petroquímico'
  },
  {
    'id': 134,
    'nome': 'Sinderurgia e Metalurgia'
  },
  {
    'id': 135,
    'nome': 'Tecnologia e Computação'
  }
]

export default segmentos



// WEBPACK FOOTER //
// ./src/vuex/cache/segmentos.js